import type { CSSProperties } from 'react'

/** Material Symbols Outlined — self-hosted, CSP-safe, one stroke weight. */
export type IconName =
  | 'search'
  | 'language'
  | 'mic'
  | 'auto_awesome'
  | 'settings'
  | 'edit'
  | 'inbox'
  | 'star'
  | 'sticky_note_2'
  | 'send'
  | 'draft'
  | 'schedule'
  | 'report'
  | 'delete'
  | 'reply'
  | 'forward'
  | 'volume_up'
  | 'add'
  | 'expand_more'
  | 'expand_less'
  | 'close'
  | 'check'
  | 'palette'
  | 'apps'
  | 'chevron_right'
  | 'mail'
  | 'info'
  | 'arrow_back'
  | 'light_mode'
  | 'dark_mode'
  | 'desktop_windows'
  | 'functions'
  | 'translate'
  | 'more_horiz'
  | 'menu'
  | 'view_sidebar'
  | 'attach_file'
  | 'lock'
  | 'warning'
  | 'shield'
  | 'calendar_month'
  | 'contacts'
  | 'list'
  | 'folder'
  | 'person'
  | 'logout'
  | 'upload'
  | 'manage_accounts'
  | 'location_on'
  | 'image'
  | 'forum'

type Props = {
  name: IconName
  className?: string
  size?: number
  label?: string
  style?: CSSProperties
}

export function Icon({ name, className = '', size = 20, label, style }: Props) {
  return (
    <span
      className={`material-symbols-outlined ${className}`.trim()}
      style={{ fontSize: size, ...style }}
      aria-hidden={label ? undefined : true}
      aria-label={label}
      role={label ? 'img' : undefined}
    >
      {name}
    </span>
  )
}
